export default {
    settings: 'Settings',
    overview: 'Overview',
    incidents: 'Incidents',
    insights: 'Insights',
    workflows: 'Workflows',
    assets: 'Assets',
    members: 'Members',
    analytics: 'Analytics Reports',
    'custom-tables': 'Custom table',
    'export-history': 'Export history',
    'import-history': 'Import history',
}
